import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import {
  errorNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  Link,
  Avatar,
  InputAdornment,
  IconButton,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import bglogo from "../../Assets/Images/bglogin.jpg";
import logo from "../../Assets/Images/f00c31d28a1eab4518d447421a5689b4f924c23b.png";
import avatar from "../../Assets/Images/loginavatar.png";

const LoginPage = ({ setRole, loginUser }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  const handleRememberChange = (event) => {
    setRememberPassword(event.target.checked);
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("SWA_userRole") || sessionStorage.getItem("SWA_userRole");

    if (["admin", "candidate", "client"].includes(isLoggedIn)) {
      navigate("/");
    }

    if (localStorage?.getItem("SWA_RememberPassword_loginUser") == loginUser) {
      if (localStorage?.getItem("SWA_RememberPassword") == "true") {
        setRememberPassword(localStorage?.getItem("SWA_RememberPassword") == "true" ? true : false);
        setUsername(localStorage.getItem("SWA_RememberedUsername") || "");
        setPassword(localStorage.getItem("SWA_RememberedPassword") || "");
      } else {
        setRememberPassword(false);
        setUsername("");
        setPassword("");
      }
    } else {
      setRememberPassword(false);
      setUsername("");
      setPassword("");
    }
  }, [navigate]);



  
  const handleLogin = () => {
    if (!username || !password) {
      toast.error("Please enter both Username and Password!");
      return;
    }

    const config = {
      admin: {
        url: "/Employee/login",
        payload: {
          ED_UserName: username,
          ED_Password: password,
        },
      },
      candidate: {
        url: "/Candidate/login",
        payload: {
          CI_UserName: username,
          CI_Password: password,
        },
      },
      client: {
        url: "/Client/login",
        payload: {
          CD_UserName: username,
          CD_Password: password,
        },
      },
    };

    const current = config[loginUser?.toLowerCase()];

    if (!current) {
      errorNotify("Invalid user role selected");
      return;
    }

    setIsLoading(true);

    axiosAPI
      .post(current.url, current.payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.data?.success == false) {
          errorNotify(res?.data?.data?.message);
        } else {
          if (res?.data?.data?.token) {
            localStorage?.setItem("SWA_RememberPassword", rememberPassword);
            localStorage?.setItem("SWA_RememberPassword_loginUser", loginUser);

            if (rememberPassword) {
              localStorage.setItem("SWA_userRole", loginUser);
              localStorage.setItem("SWA_token", res?.data?.data?.token);
              localStorage.setItem("SWA_UserId", res?.data?.data?.User_Id);

              // ✅ Store credentials if Remember Me is checked
              localStorage.setItem("SWA_RememberedUsername", username);
              localStorage.setItem("SWA_RememberedPassword", password); // Optional: avoid this if insecure
            } else {
              sessionStorage.setItem("SWA_userRole", loginUser);
              sessionStorage.setItem("SWA_token", res?.data?.data?.token);
              sessionStorage.setItem("SWA_UserId", res?.data?.data?.User_Id);

              // ❌ Clear stored credentials if Remember Me is not checked
              localStorage.removeItem("SWA_RememberedUsername");
              localStorage.removeItem("SWA_RememberedPassword");
            }

            successNotify("Logged in Successfully");
            setRole(loginUser);
            navigate("/");
          } else {
            errorNotify("Invalid Credentials");
          }
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          errorNotify(err?.response?.data?.message);
        } else {
          errorNotify("Something went wrong");
        }

        setIsLoading(false);
      });
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <Grid container sx={{ height: "100%" }}>
        {/* Left Side */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          sx={{
            position: "relative",
            overflow: "hidden",
            backgroundImage: { xs: "", sm: "", md: "", lg: `url(${bglogo})` },
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundColor: "white",
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              color: "#004f9e",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              textAlign: "center",
              padding: 4,
              height: "100%",
            }}
          >
            <Box
              sx={{
                position: "relative",
                top: { xs: `0px`, md: "0px", lg: "150px" },
                mb: 4,
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{ width: "350px", maxWidth: "100%" }}
              />
            </Box>
            <Typography
              sx={{
                position: "relative",
                display: { xs: `none`, md: "none", lg: "block" },
                top: { xs: `0px`, md: "0px", lg: "150px" },
                fontFamily: "Geist, sans-serif",
              }}
              fontWeight="bold"
            >
              Signature leads global recruitment with precision and efficiency,
              <br />
              connecting businesses worldwide with top talent tailored to their
              unique needs.
            </Typography>
            <Typography
              sx={{
                position: "relative",
                top: { xs: `0px`, md: "0px", lg: "150px" },
                display: { xs: `none`, md: "none", lg: "block" },
                fontFamily: "Geist, sans-serif",
              }}
              fontWeight="bold"
            >
              Get a call back,{" "}
              <Link
                href="#"
                style={{ color: "#004f9e", textDecoration: "none" }}
              >
                Learn more
              </Link>
            </Typography>
          </Box>
        </Grid>

        {/* Right Side */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          sx={{
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "#006CB8",
            padding: "20px",
          }}
        >
          <Box
            sx={{
              backdropFilter: "blur(10px)",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              // boxShadow: "0 0 20px rgba(255, 255, 255, 0.4)",
              borderRadius: "16px",
              border: "1px solid rgba(255, 255, 255, 0.17)",
              padding: "40px 30px",
              maxWidth: "450px",
              width: "100%",
            }}
          >
            <Box textAlign="center">
              <Avatar
                src={avatar}
                sx={{
                  height: "150px",
                  width: "150px",
                  margin: "auto",
                }}
              />
              <Typography
                variant="h4"
                sx={{
                  mb: 3,
                  fontFamily: "Geist, sans-serif",
                  fontWeight: `400`,
                  fontSize: `40px`,
                  lineHeight: `100%`,
                  letterSpacing: `0%`,
                  color: "white",
                  textTransform: "capitalize",
                }}
              >
                Login
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 4,
                position: { lg: "relative" },
                bottom: { md: `0px`, lg: "50px" },
                width: "100%",
                maxWidth: 400,
                padding: "20px",
              }}
            >
              <TextField
                label="Username"
                variant="standard"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                InputLabelProps={{
                  style: {
                    color: "#fff",
                    fontSize: "18px",
                    fontWeight: "600",
                    fontFamily: "Geist, sans-serif",
                  },
                }}
                InputProps={{
                  style: {
                    color: "#fff",
                    borderBottom: "2px solid white",
                    height: "55px",
                    fontFamily: "Geist, sans-serif",
                  },
                }}
                sx={{ my: 3 }}
              />
              <TextField
                label="Password"
                variant="standard"
                type={showPassword ? "text" : "password"}
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputLabelProps={{
                  style: {
                    color: "#fff",
                    fontSize: "18px",
                    fontWeight: "600",
                    fontFamily: "Geist, sans-serif",
                  },
                }}
                InputProps={{
                  style: {
                    color: "#fff",
                    borderBottom: "2px solid white",
                    height: "55px",
                    fontFamily: "Geist, sans-serif",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={toggleShowPassword}
                        edge="end"
                        sx={{ color: "#fff" }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{ mt: 1, mb: 1 }}
              />
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ my: 2 }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rememberPassword}
                      onChange={handleRememberChange}
                      sx={{
                        color: "#fff", // unchecked color
                        height: "15px",
                        "&.Mui-checked": {
                          color: "#fff", // checkmark color when checked
                        },
                        "&.Mui-checked + .MuiTypography-root": {
                          color: "#fff", // label color if needed
                        },
                      }}
                    />
                  }
                  label={
                    <Typography
                      sx={{ fontSize: 14, fontFamily: "Geist, sans-serif" }}
                    >
                      Remember Password
                    </Typography>
                  }
                  sx={{ color: "#fff" }}
                />
                {/* <Link
                  href="#"
                  underline="hover"
                  sx={{
                    color: "#fff",
                    fontSize: 14,
                    fontFamily: "Geist, sans-serif",
                  }}
                >
                  Forgot Password?
                </Link> */}
              </Box>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  mt: 5,
                  backgroundColor: "#fff",
                  color: "#000",
                  fontWeight: "bold",
                  padding: "15px",
                  borderRadius: "10px",
                  "&:hover": { backgroundColor: "#eee" },
                  "&.Mui-disabled": {
                    backgroundColor: "#fff", // white background when disabled
                    color: "#888", // lighter text color when disabled
                    opacity: 0.7, // slightly faded look (optional)
                  },
                }}
                onClick={handleLogin}
                disabled={isLoading} // Disable button while loading
              >
                {isLoading ? "Logging In..." : "Login"}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPage;
